<template>
    <div class="speciality-partners-group">
        <div class="partners-logos">
            <v-tooltip
                v-for="partnership in partnerships"
                :key="partnership.id"
                :disabled="!partnership.banner.tooltip"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-img
                        :class="{ 'cursor-pointer': partnership.banner.link }"
                        :src="partnership.banner.url"
                        :width="bannerWidth"
                        :height="bannerHeight"
                        v-on="on"
                        @click.prevent="windowOpen(partnership.banner.link, '_blank')"
                    />
                </template>
                <span>{{ partnership.banner.tooltip }}</span>
            </v-tooltip>
        </div>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <div class="speciality-name" v-on="on">
                    {{ specialityName }}
                </div>
            </template>
            <span>{{ specialityName }}</span>
        </v-tooltip>
    </div>
</template>

<script>
    import { windowOpen } from '@/utils/htmlUtils';

    const BANNER_WIDTH = 105;
    const BANNER_HEIGHT = 45;

    export default {
        name: 'SpecialityPartnersGroup',
        props: {
            specialityName: {
                type: String,
                required: true
            },
            partnerships: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                bannerWidth: BANNER_WIDTH,
                bannerHeight: BANNER_HEIGHT
            };
        },
        methods: {
            windowOpen
        }
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';

    $logos-per-row: 3;
    $banner-width: 105px;
    $logos-gap: 16px;

    .speciality-partners-group {
        width: $logos-per-row * $banner-width + ($logos-per-row - 1) * $logos-gap;
        max-width: 100%;
    }

    .partners-logos {
        display: grid;
        grid-template-columns: repeat($logos-per-row, $banner-width);
        gap: $logos-gap;

        .v-image {
            filter: grayscale(100%);
        }
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .speciality-name {
        margin-top: 0.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media screen and (max-width: breakpoint('sm')) {
        .partners-logos {
            justify-content: center;
        }
    }
</style>
